module.exports = __webpack_public_path__ + "static/november-1-fe63b31f372bf0fa3e3243c139e38cb9.png";